module.exports = __webpack_public_path__ + "img/icon-eye.e681eede.svg";